import type { PolyLine2 } from "geom/polyLine2Types";

export type RoomOutlines = {
  [key in RoomOutlineType]?: PolyLine2;
};

export enum RoomOutlineType {
  INSIDE_OF_MASS_IGNORE_VOID = "INSIDE_OF_MASS_IGNORE_VOID",
  INSIDE_OF_MASS_MAX_OFFSET = "INSIDE_OF_MASS_MAX_OFFSET",
  INSIDE_OF_MASS = "INSIDE_OF_MASS",
  INSIDE_OF_STRUCTURE = "INSIDE_OF_STRUCTURE",
}
